import React, { Fragment, useState, useEffect, useRef } from "react";
import Loader from "react-loader-spinner";
import CustomLoader from "../../customLoader/CustomLoader";
import GetAdminService from "../../../services/admin/GetAdminService";
import GetStudentService from "../../../services/SchoolIT/GetStudentService";
import AppHeader from "../../../Layout/AppHeader";
import AppSidebar from "../../../Layout/AppSidebar";
import StudentImportConfirmation from "../../counselor/studentImportConfirmationModal/StudentImportConfirmationModal";
import "../AdminPages.css";
const Import = () => {
  const [dataForDownload] = useState([]);
  const [loadingForStudentCsvDownload, setLoadingForStudentCsvDownload] = useState(false);
  const [schoolName, setSchoolName] = useState();
  const [showSchoolNameContainer, setShowSchoolNameContainer] = useState(false);
  const [schoolNameList, setSchoolNameList] = useState();
  const schoolNameRef = useRef();
  const timeoutRef = useRef();
  const [showDownload, setShowDownload] = useState(false);
  const [schoolNameLoading, setSchoolNameLoading] = useState(false);
  const selectedFileRef = useRef();
  const [showModal, setShowModal] = useState(false);
  const [uploadCSVData] = useState();
  const getSchoolsList = value => {
    GetAdminService.getSchoolsList(value).then(data => {
      setSchoolNameList(data?.data?.school);
      setSchoolNameLoading(false);
    }).catch(_error => {
      setSchoolNameLoading(false);
    });
  };
  const downloadFile = (downloadURL, fileName) => {
    const downloadLink = document.createElement('a');
    document.body.appendChild(downloadLink);
    downloadLink.download = fileName;
    downloadLink.href = downloadURL;
    downloadLink.click();
  };
  const getDataForCSVDownload = () => {
    setLoadingForStudentCsvDownload(true);
    GetStudentService.getStudentCountForCSVImport(schoolNameList[0].id).then(data => {
      downloadFile(data.data.download);
      setLoadingForStudentCsvDownload(false);
      // if (data.data.meta.next !== null) {
      //   data.data.objects.map((item) => {
      //     let obj = {
      //       ...item.student,
      //       ...{ counselor_email: item?.counselor?.email },
      //     };
      //     finalObj.push(obj);
      //   });
      //   setDataForDownload(finalObj);
      // } else if (data.data.meta.next === null) {
      //   data.data.objects.map((item) => {
      //     let obj = {
      //       ...item.student,
      //       ...{ counselor_email: item?.counselor?.email },
      //     };
      //     finalObj.push(obj);
      //   });
      //   let arr = [...dataForDownload, ...finalObj];
      //   setDataForDownload(arr);
      //   let result_csv = getHeaderRow();
      //   addStudentsToCsv(result_csv, arr);
      //   setLoadingForStudentCsvDownload(false);
      // }
    }).catch(_error => {
      setLoadingForStudentCsvDownload(false);
    });
  };
  useEffect(() => {
    if (dataForDownload.length > 0) {
      getDataForCSVDownload();
    }
  }, [dataForDownload && dataForDownload.length > 0]);

  // useEffect(() => {
  //   if (dataForDownload.length > 0) {
  //     let result_csv = getHeaderRow();
  //     addStudentsToCsv(result_csv, dataForDownload);
  //   }
  // }, [dataForDownload?.length > 0 && downloadCSVStudent === true]);

  // const uploadFileHandler = () => {
  //   let file = selectedFileRef.current.files[0];
  //   setSelectedFile(file);
  // };

  // const uploadFile = () => {
  //   let formData = new FormData();
  //   formData.append("school", schoolNameList[0]["id"]);
  //   formData.append("mode", "validation");
  //   formData.append("csv_file", selectedFile);
  //   let token = Storage.getTokenInCookie() ? Storage.getTokenInCookie() : "";
  //   fetch(`${API_URL}/api/v1/admin/upload-csv`, {
  //     method: "POST",
  //     headers: {
  //       "x-authorization": `Bearer ${token}`,
  //     },
  //     body: formData,
  //   })
  //     .then((response) => response.json())
  //     .then((data) => {
  //       setUploadCSVData(data);
  //       if (data?.error_csv?.length > 0) {
  //         setShowModal(true);
  //       }
  //     })
  //     .catch((error) => {
  //     });
  // };

  // useEffect(() => {
  //   if (selectedFileRef && selectedFile) {
  //     uploadFile();
  //   }
  // }, [selectedFile]);

  const handleSchoolName = () => {
    clearTimeout(timeoutRef.current);
    setSchoolName(schoolNameRef.current.value);
    if (!schoolNameRef.current.value) {
      setShowSchoolNameContainer(false);
      setSchoolNameList([]);
    } else {
      timeoutRef.current = setTimeout(() => {
        getSchoolsList(schoolNameRef.current.value);
      }, 1000);
      setShowSchoolNameContainer(true);
      setSchoolNameLoading(true);
    }
  };
  const handleSelectedSchoolName = item => {
    setSchoolNameList([item]);
    setShowSchoolNameContainer(false);
    setSchoolName(item.name);
    setShowDownload(true);
  };
  return <Fragment>
      <AppHeader />
      <div className="app-main">
        <AppSidebar />
        <div className="app-main__outer">
          <div className="csv-import-container">
            <div className="admin-students-page-header">
              <h2>Export Students</h2>
            </div>

            <div className="admin-students-school-selector">
              <label>Select School</label>
              <div className="school-input-wrapper">
                <input ref={schoolNameRef} type="text" placeholder="Type to search school name..." value={schoolName} onChange={handleSchoolName} autoComplete="off" />
                
                {showSchoolNameContainer && <ul className="school-dropdown">
                    {schoolNameLoading && <CustomLoader />}
                    {schoolNameList?.length > 0 && schoolNameList.map((item, index) => <li onClick={() => handleSelectedSchoolName(item)} key={index}>
                    
                          {item.name}
                        </li>)}
                  </ul>}
                
              </div>
            </div>

            {showDownload && <div className="admin-page-section">
                <div className="admin-page-card">
                  <p className="admin-page-section-title">Download Students</p>
                  <p className="admin-page-hint">
                    Download student data for the selected school as a CSV file.
                  </p>
                  <button onClick={() => getDataForCSVDownload()} className="admin-students-new-btn" disabled={loadingForStudentCsvDownload}>
                  
                    Download
                    {loadingForStudentCsvDownload && <Loader type="TailSpin" color="white" height={15} width={15} />}

                  
                  </button>
                </div>
              </div>}
            
          </div>
          {showModal && <StudentImportConfirmation student={uploadCSVData} closeHandler={() => {
          setShowModal(false);
          selectedFileRef.current.value = null;
        }} isOpen={showModal} school_it_ok={true} />}

          
        </div>
      </div>
    </Fragment>;
};
export default Import;